module.exports = __webpack_public_path__ + "images/icons/flags/PR-38460557.svg";